import React, { useEffect, useState } from 'react'
import { compose } from 'recompose'
import { Container, Grid, Typography } from '@material-ui/core'
import { withStyles, makeStyles } from '@material-ui/core/styles'
import StyledWrapper from '../../../components/StyledWrapper'
import SurveyResponseList from '../dashboard/components/SurveyResponseList'
import * as cookies from '../../../utilties/cookies'
import { withRouter } from 'react-router'

import { getCase, fetchInitialChart } from '../../../redux/actions'
import { benchmarcsSelector, caseSelector, currentCaseSelector, hasScoringGroupsSelector, isLoadingSelector, schemaSelector } from '../../../redux/selectors'

import { connect } from 'react-redux'
import { injectIntl, FormattedDate } from 'react-intl'
import { CircularProgress } from '@material-ui/core'
import trademarkImg from '../../../assets/trademark-svg.svg'

const Error = ({
    intl,
    loadCase,
    currentCase,
    thisCase,
    loadInitialChart,
    schema,
    benchmarcs,
    hasScoringGroups,
    chartLoading
}) => {

    const [patient] = useState(cookies.get('user'))

    useEffect(
        () => {
            loadCase(patient.id)
        },
        [currentCase && currentCase.Id]
    )

    useEffect(
        () => {
            if (thisCase && thisCase.circleId && thisCase.id && thisCase.protocolId)
                loadInitialChart(thisCase.circleId, thisCase.id, thisCase.protocolId, patient.languageId ? patient.languageId : 1)
        },
        [thisCase && thisCase.id]
    )

    return (
        <StyledWrapper showBackground={false}>

            <Container maxWidth="lg">
                <Grid container direction='column'>
                    <Grid item style={{padding: '6px 0', borderBottom: '2px solid' }}>
                        <Typography variant='h2' data-testid="scores-app-header" style={{ fontWeight: '600'}}>
                            {intl.formatMessage(
                                { id: "app.scores.header" },
                                {
                                TMimg: (
                                    <img
                                    alt="TM"
                                    src={trademarkImg}
                                    style={{ width: "20px", paddingBottom: "7px" }}
                                    />
                                ),
                                }
                            )}

                        </Typography>
                    </Grid>
                </Grid>
            </Container>

            <Grid container direction='column'>
                {
                    !!chartLoading
                        || !(thisCase && thisCase.id)
                        ? (
                            <Grid
                                container
                                justifyContent='center'
                                style={{
                                    paddingTop: '50px'
                                }}
                            >
                                <Grid item>
                                    <CircularProgress />
                                </Grid>
                            </Grid>
                        )
                        : <Grid item style={{width: '100%'}}>
                            <SurveyResponseList data-testid="survey-response-tabs" schema={schema} benchmarcs={benchmarcs} hasScoringGroups={hasScoringGroups} />
                        </Grid>
                }
            </Grid>
        </StyledWrapper>
    )
}

const mapStateToProps = (state, ownProps) => ({
    thisCase: caseSelector(state),
    currentCase: currentCaseSelector(state),
    schema: schemaSelector(state),
    benchmarcs: benchmarcsSelector(state),
    hasScoringGroups: hasScoringGroupsSelector(state),
    chartLoading: isLoadingSelector(state)
})

const mapDispatchToProps = (dispatch, ownProps) => ({
    loadCase: (patientId) => dispatch(getCase(patientId)),
    loadInitialChart: (circleId, caseId, protocolId, languageId) =>
        dispatch(fetchInitialChart(circleId, caseId, protocolId, languageId)),
})

const enhance = compose(
	connect(mapStateToProps, mapDispatchToProps),
	injectIntl,
	withRouter
)

export default enhance(Error)
